const formatPhoneNumber = (text: string | undefined): string => {
  if (!text) return '';

  if (!text.includes('+')) text = `+4${text}`;

  text = `${text.slice(0, 3)} ${text.slice(3)}`;
  text = `${text.slice(0, 7)} ${text.slice(7)}`;
  text = `${text.slice(0, 11)} ${text.slice(11)}`;

  return text;
};

const camelToSnakeCase = (str: string) => {
  return str
    .trim()
    .toLowerCase()
    .replace(' ', '-')
    .replace(/ *-\([^)]*\) */g, '');
};

const formatFloat = (value: number | undefined, decimals = 2) => {
  if (!value && value !== 0) return '';

  if (Number.isInteger(value)) return value.toString();

  return value.toFixed(decimals).replace(/\.?0+$/, '');
};

export { formatPhoneNumber, camelToSnakeCase, formatFloat };
